import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lp2-dummy-loading-content',
  templateUrl: './dummy-loading-content.component.html',
  styleUrls: ['./dummy-loading-content.component.scss'],
})
export class DummyLoadingContentComponent implements OnInit {
  @Input() repeatY = 1;
  @Input() repeatX = 1;
  @Input() lineHeight = 1;
  @Input() maxWidth = 10;
  @Input() minWidth = 3;
  @Input() isAvatarDummy = false;
  @Input() isCircumference = false;
  lineWidths: number[] = [];
  repeat: number[] = [];

  constructor() {}

  ngOnInit() {
    if (!this.repeatX) {
      return;
    }
    for (let i = 0; i < this.repeatX; i++) {
      const randomNumber = Math.random() * (this.maxWidth - this.minWidth) + this.minWidth;
      this.lineWidths.push(randomNumber);
    }
    if (this.repeatY) {
      this.repeat = Array.from(Array(this.repeatY).keys());
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/dummy-loading-content/dummy-loading-content.component.ts